import axios from 'axios'
import config from '../config/dev.json'
import {
  refresh
} from './auth.service.js'

let path = '/api/v1'
let url = config.host + path + '/secure/bot'
let urlNLP = config.hostnlp


import production from '../config/production.json'
if (process.env.NODE_ENV === 'production') {
  url = production.host + path + '/secure/bot'
}

export async function getdomaine() {
  return new Promise((resolve, reject) => {
    axios.post(urlNLP + '/domainlist').then((response) => {
      let res = response.data
      let listDomaine = []
      let i = 0
      res.forEach((element, index) => {
        i = index
        listDomaine.push(element.domaine)
      });
      if(res.length === i+1){
        resolve(listDomaine)
      }
     
      
    }).catch(err => {
      if (err.response.status == 401) {
        refresh().then(() => {
          resolve(getdomaine())
        }).catch(err => reject(err))
      }
    })
  })
}
export async function getBotsByUser() {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/user/infoBots').then((response) => {
      let bots = response.data.data
      resolve(bots)
    }).catch(err => {
      if (err.response.status == 401) {
        refresh().then(() => {
          resolve(getBotsByUser())
        }).catch(err => reject(err))
      }
    })
  })
}


export async function getBotById(id) {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/' + id).then((response) => {
      let bot = response.data.data
      resolve(bot)
    }).catch(err => {
      reject(err)
    })
  })
}

export async function forkBot (id) {
  return new Promise((resolve, reject) => {
    console.log('test fork in service', url + '/fork')
    axios.post(url + '/fork/'+ id).then((response) => {
      console.log("teeest response data ",response)
      resolve(response.data.data)
    }).catch(err => reject(err ))
  })
}

export async function trainBot(obj) {
  return new Promise((resolve, reject) => {
    console.log('test obj ', obj)
    axios.post(urlNLP + '/trainhamza', obj).then((respse) => {
      console.log('test respse', respse)
      axios.post(url + '/train/' + obj._id).then((resp) => {
        resolve(resp.data.data)
      })
    }).catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err', err.response.data.errors)
      Vue.prototype.$notif.show(
        (propsData = {
          title: "Error !",
          message: err.response.data.errors,
          type: "danger"
        })
      );
    })
  })
}

export async function updateTrainBot(id) {
  return new Promise((resolve, reject) => {
console.log("***********ipdate train",id)
    axios.post(url + '/train/update/' + id).then((resp) => {
      resolve(resp.data.data)
    }).catch(err => reject(err))
  })
}

export async function publishBot(obj) {
  return new Promise((resolve, reject) => {
    console.log('tets obj', obj)
    axios.post(urlNLP + '/publish', obj).then((response) => {

      let urlpublish = {
        text: response.data
      }
      console.log('test response', urlpublish)
      axios.post(url + '/publish/' + obj._id,urlpublish).then((resp) => {
        let botnews = resp.data.data
        console.log('test bot new', botnews)
        resolve(botnews)
      })
    }).catch(err => reject(err))
  })
}

export async function addBot(bot) {
  console.log("################# bot add service ", bot)
  return new Promise((resolve, reject) => {
    axios.post(url + '/creat', bot).then((response) => {
      let bot = response.data.data
      resolve(bot)
    }).catch(err => {
      reject(err)
    })
  })
}

export async function deleteBot(bot) {
  console.log("bot name",bot)
  
  return new Promise((resolve, reject) => {
    let obj= {
      id:"",
      name: ""
    }
    bot.forEach(element => {
      obj= {
        id: element._id,
        name: element.name
      }
    });
    
    if (bot._id) {
      axios.delete(url + '/remove/' + _id).then((response) => {
        axios.post(urlNLP + '/DeleteBot', obj).then((respse) => {
          console.log('test respse', respse)
          let bots = response.data.data.bot
        resolve(response.data.data)
        })
        
       }).catch(err => reject(err))
    } else {
      console.log(bot)
      bot.forEach(el => {
        axios.post(urlNLP + '/DeleteBot', obj).then((respse) => {
        axios.delete(url + '/remove/' + el._id).then((response) => {
          
            console.log('test respse', respse)
         
          let bots = response.data.data.bot
          resolve(response.data.data)
        }) }).catch(err => reject(err))
      })
    }
  })
}
export async function updateBot(bot) {
  console.log("########## update servie ###########",bot)
  return new Promise((resolve, reject) => {
    axios.put(url + '/update/' + bot._id, bot).then((response) => {
      resolve(response)
    }).catch(err => reject(err))
  })
}
export async function updateBotSwitch(bot) {
  console.log("########## update servie ###########",bot)
  return new Promise((resolve, reject) => {
    axios.put(url + '/switch/update/',bot).then((response) => {
      console.log("################### response",response)
      resolve(response)
    }).catch(err => reject(err))
  })
}
export async function updateBotDomaine(bot) {
  console.log("########## update servie ###########",bot)
  return new Promise((resolve, reject) => {
    axios.put(url + '/domaine/update/',bot).then((response) => {
      console.log("################### response",response)
      resolve(response)
    }).catch(err => reject(err))
  })
}


// WEBPACK FOOTER //
// ./src/api/bot.service.js